"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
require("jquery");
const LyytiEvent_1 = require("./Models/LyytiEvent");
class LyytiCalendarApp extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            error: false,
            events: [],
            maximumMonthsDisplayed: 3
        };
    }
    componentDidMount() {
        this.loadEvents();
    }
    /**
     * Increases the number months displayed
     */
    showMoreEvents(additionalMonthsToDisplay = 3) {
        this.setState({ maximumMonthsDisplayed: (this.state.maximumMonthsDisplayed + additionalMonthsToDisplay) });
    }
    /**
     * Requests events from LyytiApiController. Events are sorted based on their start date and saved to the state.
     */
    loadEvents() {
        this.setState({
            loading: true
        }, () => {
            $.ajax({
                type: "GET",
                url: "/api/LyytiApi/getevents",
                data: {},
                success: function (data) {
                    if (!data.results) {
                        this.setState({ error: true });
                        return;
                    }
                    const results = data.results;
                    const events = [];
                    Object.keys(results).forEach(key => {
                        events.push(new LyytiEvent_1.default(results[key]));
                    });
                    events.sort(function (event_a, event_b) { return event_a.start_time_utc - event_b.start_time_utc; });
                    this.setState({ loading: false, events });
                }.bind(this),
                error: function (err) {
                    this.setState({
                        error: true,
                        loading: false,
                    });
                }.bind(this)
            });
        });
    }
    /**
     * Iterates over the events to create content.
     * Displays alternative content if events are still being loaded or if there are no upcoming events or if events couldn't be loaded.
     */
    render() {
        if (this.state.error === true)
            return (React.createElement("div", { dangerouslySetInnerHTML: { __html: this.props.loadingEventsFailed } }));
        if (this.state.loading === true)
            return (React.createElement("div", { dangerouslySetInnerHTML: { __html: this.props.loadingEvents } }));
        if (this.state.events.length === 0)
            return (React.createElement("div", { dangerouslySetInnerHTML: { __html: this.props.noUpcomingEvents } }));
        /**
         * Main content to be rendered
         */
        const content = [];
        /**
         * Date object to store the previous month (and year) when splitting the events by the start date
         */
        let previousDate = new Date();
        previousDate.setMonth(previousDate.getMonth() - 1);
        /**
         * Index of the background color used. loops so that events of different months get different background color
         */
        let backgroundColor = 0;
        /**
         * Background colors used to fill the event box elements
         */
        const backgroundColors = ["s-themebgcolor-2", "s-themebgcolor-4"];
        let monthsDisplayed = 0;
        let eventsDisplayed = 0;
        // Iterate over the the events
        for (const event of this.state.events) {
            eventsDisplayed++;
            // Create a new heading element to separate events that occurs in the next month
            if (previousDate.getMonth() !== event.startDate.getMonth() || previousDate.getFullYear() !== event.startDate.getFullYear()) {
                monthsDisplayed++;
                if (monthsDisplayed > this.state.maximumMonthsDisplayed)
                    break; // Break the iteration if the limit for visible months is met
                previousDate = event.startDate;
                backgroundColor++;
                if (backgroundColor >= backgroundColors.length)
                    backgroundColor = 0;
                content.push(React.createElement("div", { key: 'month-' + event.start_time_utc, className: "col-xs-12 u-mb-2" },
                    React.createElement("h2", { className: "s-h2 u-tc" }, event.getHeaderForMonth())));
            }
            // Create the actual element representing the event
            content.push(React.createElement("div", { key: event.id, className: "col-lg-3 col-sm-3 col-xs-12" },
                React.createElement("a", { target: "_blank", href: event.enrollment_url },
                    React.createElement("div", { className: "o-lyyticalendar-box" + " " + backgroundColors[backgroundColor] },
                        React.createElement("h2", { className: "s-h2 u-tc s-themecolor-1 o-lyyticalendar-box__header" }, event.getFormattedStartDate())),
                    React.createElement("div", { className: "u-tl" },
                        React.createElement("p", { className: "s-body-text u-mb-0" }, event.getFormattedTime()),
                        React.createElement("h3", { className: "s-h3 u-tl u-mt-0" }, event.name)))));
        }
        ;
        // Add button for revealing more events if there are still hidden events
        const showMoreButton = (!(eventsDisplayed >= this.state.events.length)) ? (React.createElement("button", { onClick: this.showMoreEvents.bind(this), className: "o-button o-lyyticalendar-button" }, this.props.translations.showMoreEventsText)) : null;
        return (React.createElement("div", null,
            React.createElement("div", { className: "row" }, content),
            React.createElement("div", { className: "row u-flex-justify--ce u-mb-12 u-mt-8" }, showMoreButton)));
    }
}
exports.default = LyytiCalendarApp;
